export class NICEContactState{
    agentId: number;
    campaignName: string;
    campaignId: number;
    contactId: number;
    contactStateId: number;
    contactStateName: string;
    digitalContactStateName: any;
    digitalContactStateId: any;
    firstName: string;
    fromAddress: string;
    highProficiency: number;
    lastName: string;
    lowProficiency: string;
    lastUpdateTime: string;
    masterContactId: number;
    mediaTypeName: string;
    mediaTypeId: number;
    mediaSubTypeId: any;
    mediaSubTypeName: any;
    routingAttribute: number;
    skillName: string;
    skillId: number;
    startDate: string;
    teamName: string;
    teamId: number;
    toAddress: string;

    constructor(data: any) {
        this.agentId = data.agentId;

        this.campaignName = data.campaignName;
        this.campaignId = data.campaignId;
        this.contactId = data.contactId;
        this.contactStateId = data.contactStateId;
        this.contactStateName = data.contactStateName;
        this.digitalContactStateName = data.digitalContactStateName;
        this.digitalContactStateId = data.digitalContactStateId;
        this.firstName = data.firstName;
        this.fromAddress = data.fromAddress;
        this.highProficiency =data.highProficiency;
        this.lastName = data.lastName;
        this.lowProficiency = data.lowProficiency;
        this.lastUpdateTime = data.lastUpdateTime;
        this.masterContactId = data.masterContactId;
        this.mediaTypeName = data.mediaTypeName;
        this.mediaTypeId = data.mediaTypeId;
        this.mediaSubTypeId = data.mediaSubTypeId;
        this.mediaSubTypeName = data.mediaSubTypeName;
        this.routingAttribute = data.routingAttribute;
        this.skillName = data.skillName;
        this.skillId = data.skillId;
        this.startDate = data.startDate;
        this.teamName = data.teamName;
        this.teamId = data.teamId;
        this.toAddress = data.toAddress;
    }
}
